import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { api, getListItems } from "../../services/api";
import { getImageUrl } from "../../utils/imageUrl";
import { useSiteContent, sectionField } from "../../hooks/useSiteContent";

function TourGuide() {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [guides, setGuides] = useState([]);
  const paginationRef = useRef(null);
  const { content } = useSiteContent("home");

  const subtitle = sectionField(content, "guides", "subtitle", "Meet with Guide");
  const title = sectionField(content, "guides", "title", "Tour Guide");
  const roleLabel = sectionField(content, "guides", "role_label", "Tourist Guide");
  const bgImage = sectionField(content, "guides", "bg_image", "/assets/img/bg/team_bg_1.png");

  useEffect(() => {
    let cancelled = false;
    api.getGuides()
      .then((res) => {
        if (cancelled) return;
        const items = getListItems(res).map((g) => ({
          id: g.id,
          name: g.name || g.title || "Guide",
          image: getImageUrl(g.image || g.banner_image, "team") || "/assets/img/team/team_1_1.jpg",
          role: g.designation || g.role || roleLabel,
        }));
        setGuides(items);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [roleLabel]);

  useEffect(() => {
    if (swiperInstance && paginationRef.current) {
      swiperInstance.params.pagination.el = paginationRef.current;
      swiperInstance.pagination.init();
      swiperInstance.pagination.update();
    }
  }, [swiperInstance, guides]);

  if (!guides.length) {
    return null;
  }

  return (
    <section
      className="bg-smoke space overflow-hidden"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="container z-index-common">
        <div className="title-area text-center">
          <span className="sub-title">{subtitle}</span>
          <h2 className="sec-title">{title}</h2>
        </div>
        <div className="slider-area">
          <Swiper
            modules={[Pagination, Autoplay]}
            slidesPerView={1}
            spaceBetween={20}
            speed={1200}
            breakpoints={{
              576: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            className="th-slider teamSlider1 has-shadow"
            onSwiper={setSwiperInstance}
          >
            {guides.map((guide) => (
              <SwiperSlide key={guide.id}>
                <div className="th-team team-box">
                  <div className="team-img">
                    <img
                      src={guide.image}
                      alt={guide.name}
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = "/assets/img/team/team_1_1.jpg";
                      }}
                    />
                  </div>
                  <div className="team-content">
                    <div className="media-body">
                      <h3 className="box-title">
                        <Link to={`/tour-guide/${guide.id}`}>{guide.name}</Link>
                      </h3>
                      <span className="team-desig">{guide.role}</span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default TourGuide;
